import { PassEncryption } from './encryption';

export interface IOperatingMode {
	operatingMode: string;
	version: string;
	linkHome: string;
	linkAbout: string;
	linkAdministrators: string;
	linkBrokers: string;
	linkCounselors: string;
	useSecondaryCaptcha: boolean;
}

export class OperatingMode implements IOperatingMode {
	operatingMode: string;
	version: string;
	linkHome: string;
	linkAbout: string;
	linkAdministrators: string;
	linkBrokers: string;
	linkCounselors: string;
	useSecondaryCaptcha: boolean;

	constructor() {
		this.operatingMode = '';
		this.version = '';
		this.linkHome = '';
		this.linkAbout = '';
		this.linkAdministrators = '';
		this.linkBrokers = '';
		this.linkCounselors = '';
		this.useSecondaryCaptcha = false;
	}
}

export class ValidatePasswordPayload {
	username: string;
	password: string;
	systemNumber: string;

	constructor() {
		this.username = null;
		this.password = null;
		this.systemNumber = null;
	}
}


export class VerifyCompanyLocationPayload {
	companyCode: string;
	erLocationID: string;

	constructor() {
		this.companyCode = null;
		this.erLocationID = null;
	}
}

export class CompanyLocationVBO {
	companyName: string;
	companyCode: string;
	locationName: string;
	erLocationID: string;

	constructor() {
		this.companyName = null;
		this.companyCode = null;
		this.locationName = null;
		this.erLocationID = null;
	}
}

export class UpdatePasswordCriteria {
	agentID: number;
	existingPassword: string;
	newPassword: string;
	newPasswordConfirm: string;
	existingPasswordEncryption: PassEncryption;
	newPasswordEncryption: PassEncryption;
	newPasswordConfirmEncryption: PassEncryption;

	constructor() {
		this.agentID = null;
		this.existingPassword = null;
		this.newPassword = null;
		this.newPasswordConfirm = null;
		this.existingPasswordEncryption = new PassEncryption()
		this.newPasswordEncryption = new PassEncryption()
		this.newPasswordConfirmEncryption = new PassEncryption()
	}
}

export class SMSVerifyPayload {
	code: string;
	systemNumber: number;
	userId: string;
	constructor() {
		this.code = '';
		this.systemNumber = 0;
		this.userId = '';
	}
}

export class TokenResponse {
	id?: number;
	token: string;
	forceReloadCaptcha: boolean;
	useSecondary: boolean;

	constructor() {
		this.id = 0,
			this.token = '';
	}
}


export class OTPResponse {
	userId: string;
	qrCodeUrl: string;
	manualEntryCode: string;
	isVerificationSent: boolean;
	registrationReturnMessage: string;
	myWorkplaceVerificationTypeValue: string;

	constructor() {
		this.userId = '';
		this.qrCodeUrl = '';
		this.manualEntryCode = '';
		this.isVerificationSent = false;
		this.registrationReturnMessage = '';
		this.myWorkplaceVerificationTypeValue = '';
	}
}

export class PassthroughBearTokenPayload {
	id: string;

	constructor() {
		this.id = '';
	}
}

export class UpdateEmailCriteria {
	newEmail: string;
	newEmailConfirm: string;

	constructor() {
		this.newEmail = null;
		this.newEmailConfirm = null;
	}
}

export class IdentityServerRefresh {
	refreshToken: string;

	constructor() {
		this.refreshToken = null;
	}
}

export class IdentityServerGrantBase {
	isSuccess: boolean;
	accessToken: string;
	refreshToken: string;

	constructor() {
		this.isSuccess = false;
		this.accessToken = null;
		this.refreshToken = null;
	}
}
